import script from "./RatingCrystals.vue?vue&type=script&setup=true&lang=js"
export * from "./RatingCrystals.vue?vue&type=script&setup=true&lang=js"

import "./RatingCrystals.vue?vue&type=style&index=0&id=30ebcf30&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30ebcf30"]])

export default __exports__